import declare from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import domConstruct from 'dojo/dom-construct';
import domAttr from 'dojo/dom-attr';
import domClass from 'dojo/dom-class';
import domStyle from 'dojo/dom-style';
import dojoNum from 'dojo/number';
import on from 'dojo/on';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import GenericDialog from 'moreCore/UI/GenericDialog/GenericDialog';
import DateTimeDialog from '../JDM/Occurrence/DateTimeDialog/DateTimeDialog'; // (mds) OccurrenceFM is the stale twin of JDM/Occurrence; the dialog only exists there
import MultiSelectBox from '../JDM/MultiSelectBox';
import template from './OccurrencePropertiesTable.html?raw';
export default declare("WidgetCollection.JDM.Occurrence.OccurrencePropertiesTable", [_WidgetBaseSP], {
        templateString: template,

        _jsonDataIn: null,
        _jsonDataOut: null,
        _jsonDataString: "",

        isReadonly: false,
        valid: false,

        primaryKeyAttribute: "ID",
        valueAttribute: "value_text_global",
        typeAttribute: "ref_vt_property.property_type",
        mandatoryAttribute: "ref_vt_property.is_needed",
        labelAttribute: "ref_vt_property.Name",
        rows: null,

        header: null,

        //drawHeader: function () {
        //    if (header != null) {
        //        domConstruct.destroy(header);
        //    }

        //    this.header = domConstruct.create("")
        //},

        drawRow: function (entity) {

            var entityID = this.PitHelper.getEntityAttributeValue(entity, this.primaryKeyAttribute);
            var row = this.getRowByKey(entityID);

            if (row != null) {
                domConstruct.destroy(row.rowNode);
                row.rowNode = null;
                row.valueNode = null;

            } else {
                row = {
                    entity: null,
                    value: null,
                    input: null,
                    rowNode: null,
                    valueNode: null,
                    type: null
                };
                this.rows.push(row);
            }

            row.type = this.PitHelper.getEntityAttributeValue(entity, this.typeAttribute);

            switch (row.type) {
                case 1: // Zahl > wegen Tausendertrennzeichen und so das tatsächliche Wertattribut auslesen
                    row.value = this.PitHelper.getEntityAttributeValue(entity, "value_double");
                    break;
                default:
                    row.value = this.PitHelper.getEntityAttributeValue(entity, this.valueAttribute);
                    break;
            }

            row.entity = entity;


            var tr = domConstruct.create("tr",
                {
                    "className": "propRow",
                },
                this.tbodyContainer);
            row.rowNode = tr;

            //console.debug("occurrenceproperties drawrow", entity, tr, this.isReadonly);

            var td = domConstruct.create("td",
                {
                    "innerHTML": this.PitHelper.getEntityAttributeValue(row.entity, this.labelAttribute),
                    //"className": "flex_row_center"
                    style: {
                        "verticalAlign": "middle" // warum auch immer w3 das TOP macht in einem td-Element. >_>
                    }
                }, tr);


            td = domConstruct.create("td",
                {
                    "className": "flex_row_center"
                }, tr);

            row.valueNode = td;
            this.constructInput(row);

            //if (columnInput != null) {
            //    domConstruct.place(columnInput, td);
            //}

            var unit = "";
            if (row.entity.ref_unit != null && row.entity.ref_unit.ID != "") {
                unit = this.PitHelper.getEntityAttributeValue(row.entity, "ref_vt_property.ref_unit.Name");
            } else if (row.entity.ref_vt_property.ref_unit != null && row.entity.ref_vt_property.ref_unit.ID != "") {
                unit = this.PitHelper.getEntityAttributeValue(row.entity, "ref_vt_property.ref_unit.Name");
            }
            td = domConstruct.create("td",
                {
                    "innerHTML": unit,
                    style: {
                        "verticalAlign": "middle" // warum auch immer w3 das TOP macht in einem td-Element. >_>
                    }
                    //"className": "flex_row_center"
                }, tr);


        },

        checkMandatory: function (targetRow) {
            var isValid = true;

            //console.debug("checkMandatory", this.rows, targetRow);

            if (this.isReadonly === true) {
                this.isValid = true;
                return;
            }

            var targetRows = []
            if (typeof (targetRow) != "undefined" && targetRow != null) {
                targetRows.push(targetRow);
            } else {
                targetRows = this.rows;
            }

            for (var i = 0; i < targetRows.length; i++) {
                var row = targetRows[i];
                var isMandatory = false;
                var check = true;

                if (true) {

                    isMandatory = this.PitHelper.getEntityAttributeValue(row.entity, this.mandatoryAttribute);

                    switch (row.type) {
                        case 0: // Text
                        case 1: // Zahl
                        case 2: // einfaches Select
                        case 5: // datum


                            check = row.input.value != "" && row.input.value != null;
                            //console.debug("checkMandatory", isMandatory, row.type, check, this.PitHelper.getEntityAttributeValue(row.entity, this.labelAttribute), row.input.value);
                            break;

                        case 3: // mehrfachauswahl
                            check = row.input.get("value").length > 0;
                            //console.debug("checkMandatory multiselect", isMandatory, check, this.PitHelper.getEntityAttributeValue(row.entity, this.labelAttribute), row.input.get("value"));
                            break;

                        case 6: // datum + zeit
                            check = row.input.value != "" && row.input.value != null;
                            if (!isMandatory && check == true) {
                                domClass.remove(row.clearButton, "w3-hide");
                            } else {
                                domClass.add(row.clearButton, "w3-hide");
                            }
                            break;

                        case 4:
                        case 41:
                            //console.debug("checkMandatory file", row.value);
                            check = false;
                            for (var x = 0; x < row.value.length; x++) {
                                var file = row.value[x];
                                if (file.isRemove !== true) {
                                    check = true;
                                    break;
                                }
                            }
                            break;

                    }

                    if (isMandatory === true && check != true) {
                        isValid = false;
                        domClass.add(row.rowNode, "w3-pale-red");
                    } else {
                        domClass.remove(row.rowNode, "w3-pale-red");
                    }
                }
            }

            if (typeof (targetRow) != "undefined" && targetRow != null) {
                if (isValid !== true) {
                    this.isValid = false;
                    return;
                }
            }
            this.isValid = isValid;
        },

        constructInput: function (row) {
            var input = null;
            var container = null;
            var entity = row.entity;

            var isMandatory = this.PitHelper.getEntityAttributeValue(entity, this.mandatoryAttribute) === true;

            switch (row.type) {
                case 0: // text
                    input = domConstruct.create("textarea",
                        {
                            "className": "w3-padding-small w3-border w3-block",

                            "rows": "2",
                            style: {
                                "resize": "vertical",
                                //"height": "35px",
                                "padding": "8px",
                                "scroll": "auto"
                            },
                            //"type": "text",
                            //"disabled": this.isReadonly === true ? "disabled" : "false",
                            "value": this.PitHelper.getEntityAttributeValue(entity, this.valueAttribute)
                        }, row.valueNode);

                    if (this.isReadonly === true) {
                        domAttr.set(input, "disabled", "true");
                    }


                    input.value = row.value;

                    break;

                case 1: // Zahl
                    input = domConstruct.create("input",
                        {
                            "className": "w3-input w3-border",
                            "type": "number",
                            //"disabled": this.isReadonly === true ? "disabled" : "false",
                            "value": this.PitHelper.getEntityAttributeValue(entity, "value_double")
                        }, row.valueNode);
                    if (this.isReadonly === true) {
                        domAttr.set(input, "disabled", "true");
                    }

                    input.value = parseFloat(row.value);
                    break;

                case 2: // Werteliste (Einfachauswahl)
                    input = domConstruct.create("select",
                        {
                            "className": "w3-input w3-border",
                        }, row.valueNode);

                    // leer Option erzeugen
                    var option = domConstruct.create("option", {}, input);
                    option.value = "";
                    domAttr.set(option, "innerHTML", this.translations["General_DropdownBlank_Choose"]);

                    var options = [];
                    var cellValue = row.value;
                    for (var i = 0; i < entity.ref_vt_property.EL_vt_property_value_vt_property.length; i++) {
                        var propValue = entity.ref_vt_property.EL_vt_property_value_vt_property[i];

                        var option = domConstruct.create("option", {}, input);
                        option.value = propValue.bezeichnung;
                        domAttr.set(option, "innerHTML", propValue.bezeichnung);

                        if (propValue.Description != null && propValue.Description != "") {
                            domAttr.set(option, "title", propValue.Description);
                        }

                        if (cellValue != "" && cellValue != null && typeof (cellValue) != "undefined") {
                            if (cellValue == option.value) {
                                domAttr.set(option, "selected", "true");
                            }
                        }

                        options.push(option);
                    }

                    input.style.width = "100%";
                    if (this.isReadonly === true) {
                        domAttr.set(input, "disabled", "true");
                    }

                    if (row.value != "" && row.value != null) {
                        input.value = row.value;
                    }

                    break;

                case 3: // Werteliste (Mehrfachauswahl)
                    input = new MultiSelectBox;
                    input.labelAttribute = "bezeichnung";
                    input.value = "ID";

                    if (this.isReadonly === true) {
                        input.set("readonly", true);
                    }

                    domConstruct.place(input.domNode, row.valueNode);

                    var cellValue = row.value;
                    var selectedValues = [];
                    if (cellValue != "" && cellValue != null && typeof (cellValue) != "undefined") {
                        selectedValues = cellValue.split(" | ");
                    }
                    var options = [];
                    var selectedIDs = [];
                    for (var i = 0; i < entity.ref_vt_property.EL_vt_property_value_vt_property.length; i++) {
                        var propValue = entity.ref_vt_property.EL_vt_property_value_vt_property[i];
                        options.push(propValue);

                        if (selectedValues.indexOf(propValue.bezeichnung, 0) != -1) {
                            selectedIDs.push(propValue.ID);
                        }
                    }

                    input.buildListValues(options, selectedIDs);

                    row.value = input.get("value");
                    break;

                case 4: // file (single)
                case 41: // file (multi)
                    row.downloads = [];

                    container = domConstruct.create("div", {
                        "className": "flex_row_center",
                        style: {
                            "width": "100%"
                        }
                    }, row.valueNode);

                    row.downloadsNode = container;

                    //if (this.isReadonly !== true) {
                    input = domConstruct.create("input",
                        {
                            "className": "w3-block w3-padding-y",
                            "type": "file",
                            //"disabled": this.isReadonly === true ? "disabled" : "false",
                        }, row.valueNode);

                    if (row.type == 41) {
                        domAttr.set(input, "multiple", "true");
                    }
                    //}
                    row.input = input; // muss hier gesetzt werden bei files, weil readattachments drauf zugreift
                    this.readAttachments(row);
                    break;

                case 5: // datum
                    input = domConstruct.create("input",
                        {
                            "className": "w3-input w3-border",
                            "type": "date",
                            //"disabled": this.isReadonly === true ? "disabled" : "false",
                            "value": this.PitHelper.getEntityAttributeValue(entity, this.valueAttribute)
                        });
                    if (this.isReadonly === true) {
                        domAttr.set(input, "disabled", "true");
                    }

                    domConstruct.place(input.domNode, row.valueNode);
                    break;

                case 6: // datum + zeit

                    container = domConstruct.create("div", {
                        "className": "flex_row_center",
                        style: {
                            "width": "100%"
                        }
                    }, row.valueNode);
                    input = domConstruct.create("input",
                        {
                            "className": "w3-input w3-border",
                            style: {
                                "flex": "1"
                            },
                            "type": "text",
                            "disabled": "disabled",
                            "value": this.PitHelper.getEntityAttributeValue(entity, this.valueAttribute)
                        }, container);


                    if (this.isReadonly !== true) {
                        var dlgButton = domConstruct.create("div", {
                            "className": "mds-button-base round w3-2018-quiet-gray mds-hover-bright w3-large w3-padding-small",
                            //"innerHTML": "..."
                            style: {
                                "marginLeft": "2px",
                                "minWidth": "60px"
                            }
                        }, container);
                        on(dlgButton, "click", lang.hitch(this, this._showDatetimeDialog, row));

                        domConstruct.create("i", {
                            "ariaHidden": "true",
                            "className": "fa fa-clock-o"
                        }, dlgButton);

                        if (true) {
                            var clearButton = domConstruct.create("div", {
                                "className": "w3-hide mds-button-base round w3-pale-red mds-hover-bright w3-large w3-padding-small w3-text-red",
                                //"innerHTML": "..."
                                style: {
                                    "marginLeft": "2px"
                                }
                            }, container);
                            on(clearButton, "click", lang.hitch(this, this._clearDateTime, row));

                            domConstruct.create("i", {
                                "ariaHidden": "true",
                                "className": "fa fa-times"
                            }, clearButton);

                            row.clearButton = clearButton;
                        }

                    }

                    break;
            }

            row.input = input;

            // change-Events anhängen und raus
            if (this.isReadonly !== true) {
                switch (row.type) {
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 5:
                    case 6: //datetime

                        on(row.input, "change", lang.hitch(this, this._onInputChanged, row));
                        break;

                    case 4: // file single
                    case 41: // file multi
                        on(row.input, "change", lang.hitch(this, this._onInputChanged, row));
                        //this.readAttachments(row);
                        break;
                }
            }
        },

        _onInputChanged: function (row) {
            if (this.isReadonly == true) {
                return;
            }
            switch (row.type) {
                case 0: // Text
                case 1: // Zahl
                case 2: // einfachauswahl
                case 5: // date
                case 6: //datetime

                    row.value = row.input.value;
                    break;
                case 3:

                    row.value = row.input.get("value");
                    break;

                case 4: // file single
                case 41: // file multi
                    this.readFileInput(row);
                    break;
            }

            this.checkMandatory(row);
            this.buildOutput();
        },

        readFileInput: function (row) {
            var value = row.input.files;

            //console.log("_onInputChanged", value, row.input);

            // alle Files aus dem Input per Filereader auslesen
            for (var i = 0; i < value.length; i++) {
                var reader = new FileReader();
                var file = value[i];

                reader.onload = lang.hitch(this, function (value, name, row) {

                    if (value.error != null) {
                        return;
                    }

                    var newValue = {
                        rawData: value.result,
                        filename: name
                    };

                    // neues File-Objekt als Descriptor in die Row:
                    var descriptor = this.addAttachmentDescriptor(row, newValue);
                    this.addDownloadButton(row, descriptor);
                    this.setUploadButtonVisibility(row);
                    this.checkMandatory(row);
                    this.buildOutput();

                }, reader, file.name, row);
                //reader.onerror = lang.hitch(this, "_onFileReader_Error");

                reader.readAsDataURL(file);
            }

        },

        readAttachments: function (row) {

            var filesValue = this.PitHelper.getEntityAttributeValue(row.entity, this.valueAttribute);

            //console.debug("readAttachments", row, filesValue);

            row.value = []; // value wird im addAttachmentDescriptor auf die download-Blobs geändert
            // wenn es aber keine Downloads gibt, steht in value der Wert aus der API, dann weicht das voneinander ab -> blöd
            // also value einmal auf neues Array umschreiben, dann stimmts sicher

            if (filesValue != null && filesValue != "") {
                var existingFiles = filesValue.files;
                for (var d = 0; d < existingFiles.length; d++) {
                    this.addAttachmentDescriptor(row, existingFiles[d]);
                }
            }

            this.drawDownloadButtons(row);
        },

        addAttachmentDescriptor: function (targetrow, fileData) {
            var descriptor = {
                data: fileData,
                isVirtual: typeof (fileData.ID) == "undefined",
                isRemove: false,
                buttonLabel: fileData.filename
            };

            targetrow.downloads.push(descriptor);

            targetrow.value = targetrow.downloads;

            //console.debug("addAttachmentDescriptor", descriptor, fileData, targetrow);

            return descriptor;
        },

        drawDownloadButtons: function (row) {
            var descriptorList = row.downloads;
            //console.log("drawDownloadButtons", row, descriptorList);

            domConstruct.empty(row.downloadsNode);

            for (var i = 0; i < descriptorList.length; i++) {

                var download = descriptorList[i];

                // Prozedur überspringen, wenn das Attachment noch nicht in DB steht und schon wieder entfernt wurde
                if (download.isVirtual === true && download.isRemove === true) {
                    continue;
                }

                this.addDownloadButton(row, download);
            }

            this.setUploadButtonVisibility(row);
        },

        addDownloadButton: function (row, descriptor) {

            var download = descriptor;
            var container = domConstruct.create("div",
                {
                    "className": "flex_row_center w3-padding-y w3-margin-right"
                },
                row.downloadsNode);

            var dlButton = domConstruct.create("div");
            domClass.add(dlButton, "w3-padding-small");
            domAttr.set(dlButton, "innerHTML", download.buttonLabel);
            domConstruct.place(dlButton, container);

            if (download.isVirtual != true) {
                domAttr.set(dlButton, "textDecoration", "none");

                var icon = domConstruct.create("i");
                domClass.add(icon, "fa fa-download w3-margin-left");
                //domStyle.set(icon, "display", "none");
                //domStyle.set(icon, "marginLeft", "6px");
                domConstruct.place(icon, dlButton);

                if (download.isRemove === true) {
                    domClass.add(dlButton, "w3-gray w3-disabled"); //w3-2018-nebulas-blue");
                    domStyle.set(dlButton, "textDecoration", "line-through");
                }

                else {// (download.isRemove != true) {
                    domClass.add(dlButton, "mds-hover-bright w3-2018-quiet-gray"); //w3-2018-nebulas-blue");
                    on(dlButton, "click", lang.hitch(this, this._onClick_Download, download));
                }

                // nicht virtuell, nicht Schreibschutz, noch nicht "entfernt" -> darf entfernt werden
                if (this.isReadonly != true && download.isRemove != true) {

                    var removeButton = domConstruct.create("div");
                    domClass.add(removeButton, "w3-padding-small w3-pale-red mds-hover-bright");
                    domConstruct.place(removeButton, container);

                    var icon = domConstruct.create("i");
                    domClass.add(icon, "fa fa-times-circle w3-text-red");
                    //domStyle.set(icon, "display", "none");
                    //domStyle.set(icon, "marginLeft", "6px");
                    domConstruct.place(icon, removeButton);

                    on(removeButton, "click", lang.hitch(this, this._onClick_RemoveDownload, row, download));

                }

            } else {
                domClass.add(dlButton, "w3-hover-red w3-light-gray mds-hover-bright hover-strike");

                var icon = domConstruct.create("i");
                domClass.add(icon, "fa fa-times-circle w3-margin-left");
                //domStyle.set(icon, "display", "none");
                //domStyle.set(icon, "marginLeft", "6px");
                domConstruct.place(icon, dlButton);

                on(dlButton, "click", lang.hitch(this, this._onClick_RemoveDownload, row, download));
            }

            download.node = container;

        },

        setUploadButtonVisibility: function (row) {

            var activeButtons = 0;

            if (this.isReadonly != true) {
                for (var i = 0; i < row.downloads.length; i++) {
                    // jeden deskriptor prüfen ob der als aktiv gilt
                    var download = row.downloads[i];

                    if (download.isRemove != true) {
                        activeButtons++;
                    }
                }
            }

            //console.debug("setUploadButtonVisibility", activeButtons, row);

            if (this.isReadonly === true || (row.type == 4 && activeButtons > 0)) {
                domAttr.set(row.input, "disabled", "true");
                domClass.add(row.input, "w3-hide");

            } else {
                domAttr.remove(row.input, "disabled");
                domClass.remove(row.input, "w3-hide");
            }

            row.input.value = null;
        },

        removeDownloadButton: function (row, downloadDescriptor) {
            if (this.isReadonly === true) {
                return;
            }

            if (downloadDescriptor.isVirtual === true) {
                // noch nicht in DB: wir entfernen den Inhalt komplett
                downloadDescriptor.data = null;
            } else {

            }

            // remove-Flag setzen
            downloadDescriptor.isRemove = true;

            // button wird hier zerstört und nochmal neu gezeichnet:
            this.drawDownloadButtons(row);
            this.checkMandatory(row);
            this.buildOutput();

        },

        _onClick_Download: function (downloadDescriptor) {
            //console.log("_onClick_Download", downloadDescriptor);
            if (downloadDescriptor.data != null) {
                var url = window.appRoot + "Occurrence/DownloadPropertyFile?ID=" + downloadDescriptor.data.ID;
                window.open(url);
            }
        },

        _onClick_RemoveDownload: function (row, downloadDescriptor, evt) {
            //console.log("_onClick_RemoveDownload", downloadDescriptor);
            this.removeDownloadButton(row, downloadDescriptor);
        },


        buildOutput: function (bOnlyCheckDirty, bSuppressEmit) {
            var currentOutput = this._jsonDataString; //JSON.stringify(this._jsonDataOut);
            var newList = [];
            for (var i = 0; i < this.rows.length; i++) {
                var row = this.rows[i];

                newList.push({ entity: row.entity, value: row.value });

            }

            var newOutput = JSON.stringify(newList);
            //console.debug("OccurrenceProperties buildOutput", newOutput != currentOutput, newOutput.length, currentOutput.length, newList);

            if (bOnlyCheckDirty !== true) {
                this._jsonDataString = newOutput;
                this._jsonDataOut = newList;
            }

            if (newOutput != currentOutput && bSuppressEmit !== true) {
                this.emit("change", newList);
                console.log("PropertiesList output changed", newList);
            }


        },

        _clearDateTime: function (row) {
            //console.debug("_clearDateTime", row);
            row.input.value = "";
            this._onInputChanged(row);
        },

        _showDatetimeDialog: function (row) {
            var datetimedialog = new DateTimeDialog();

            //console.debug("_showDatetimeDialog", row);

            datetimedialog.set("UseTime", true);

            var cellValue = row.input.value;

            if (cellValue != null && cellValue != "") {
                datetimedialog.value = cellValue;
            }

            domConstruct.place(datetimedialog.domNode, document.body);

            datetimedialog.show(this.PitHelper.getEntityAttributeValue(row.entity, this.labelAttribute));

            var setDate = function (result, date) {
                //console.log("setDate", result, date);

                if (result == 1) {
                    row.input.value = date;
                    this._onInputChanged(row);
                } else {

                }

            };

            datetimedialog.set("callback", lang.hitch(this, setDate));
        },

        getRowByKey: function (key) {
            for (var i = 0; i < this.rows.length; i++) {
                var entity = this.rows[i].entity;

                if (this.PitHelper.getEntityAttributeValue(entity, this.primaryKeyAttribute) == key) {
                    return this.rows[i];
                }
            }

            return null;
        },

        _setDataAttr: function (data) {
            this._jsonDataIn = data;
            this.drawTable();
        },

        drawTable: function () {
            //console.debug("occurrenceproperties drawtable", this._jsonDataIn);

            domConstruct.empty(this.tbodyContainer);
            this.rows = [];

            if (this._jsonDataIn != null) {

                for (var i = 0; i < this._jsonDataIn.length; i++) {
                    this.drawRow(this._jsonDataIn[i]);
                }
            }

            this.checkMandatory();
            this.buildOutput(false, true);
        },

        startup: function () {
            this.inherited(arguments);

        },

        postMixInProperties: function () {
            this.inherited(arguments);
        },
        postCreate: function () {
            this.inherited(arguments);
            this.PitHelper._structureFormat = "json";
            this.rows = [];
        },


    });
